import { render, staticRenderFns } from "./CardCatalogueCardActionsAdd.vue?vue&type=template&id=632fb180&scoped=true"
import script from "./CardCatalogueCardActionsAdd.vue?vue&type=script&lang=js"
export * from "./CardCatalogueCardActionsAdd.vue?vue&type=script&lang=js"
import style0 from "./CardCatalogueCardActionsAdd.vue?vue&type=style&index=0&id=632fb180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632fb180",
  null
  
)

export default component.exports